import BattlesService from './BattlesService';

export default {
	'services.battlesService': {
		class: BattlesService,
		deps: [{ $ref: 'services.APIService' }],
	},
};
